import { QqBundleModel } from "../model/qq-bundle.model";
import { OptionResultModel } from "../model/option-result.model";
import { QqModel } from "../model/qq.model";
import { EquationProcessorService } from "./equation-processor.service";
import { ControlsBundleMap } from "../message-interop/qq-state.type";
import { QqBundleService } from "./qq-bundle.service";

export class OptionProcessorService {
  constructor(
    private bundle: QqBundleModel,
    private controlsBundle: ControlsBundleMap,
    private currentOption: { [key: string]: string },
    private controlsValue: { [key: string]: string[] },
    private ctrlPos: { [key: string]: any }
  ) {}

  ensureBundledCtrlsVisibility(
    key: string,
    option: string,
    bundledControls: ControlsBundleMap
  ) {
    const values = this.controlsValue;
    const options = this.currentOption;
    const ctrlPos = this.ctrlPos;

    const qqBundleService = new QqBundleService(this.bundle);

    const allBundledControls = bundledControls[key];
    if (!allBundledControls) return;

    Object.keys(allBundledControls).forEach((ctrlOption) => {
      allBundledControls[ctrlOption].forEach((key) => {
        const ctrl = qqBundleService.getControl(key);
        if (ctrl) {
          const wasVisible = ctrl.visible;
          ctrl.visible = option === ctrlOption;

          if (!ctrl.visible && values[ctrl.key] !== undefined) {
            delete values[ctrl.key];
          }
          if (!ctrl.visible && options[ctrl.key] !== undefined) {
            delete options[ctrl.key];
          }
          if (!ctrl.visible && ctrlPos[ctrl.key] !== undefined) {
            delete ctrlPos[ctrl.key];
          }

          if (wasVisible === false && ctrl.visible === true) {
            this.fillDefault(ctrl);
          }

          this.ensureBundledCtrlsVisibility(
            ctrl.key,
            options[ctrl.key],
            bundledControls
          );
        }
      });
    });
  }

  fillDefault(qq: QqModel) {
    const qqBundleService = new QqBundleService(this.bundle);

    let option = qq.settings.default;
    if (option) {
      let value: OptionResultModel | undefined = undefined;

      if (qq.type === "slider") {
        const sliderOptionRange = qqBundleService.getSliderRangeByValue(
          qq.settings.default as number,
          qq
        );

        value = sliderOptionRange?.res;
        option = JSON.stringify(sliderOptionRange?.range);
      } else {
        if (qq.optionsValue !== undefined)
          value = qq.optionsValue[qq.settings.default as string];
      }

      if (value !== undefined) this.processOption(qq, value);
      this.currentOption[qq.key] = option.toString();
      this.ctrlPos[qq.key] = qq.settings.default;
    }
  }

  processOption(qq: QqModel, option: OptionResultModel): boolean {
    switch (true) {
      case Array.isArray(option): {
        this.controlsValue[qq.key] = option as string[];
        return false;
      }
      default: {
        const equationProcessor = new EquationProcessorService(
          this.bundle,
          this.controlsBundle,
          this.currentOption
        );
        return equationProcessor.processEquation(qq, option as string);
      }
    }
  }
}
